import styled, { css } from "styled-components";
import { getCheckboxStyles, TCheckboxSize } from "./helpers";

export const Wrapper = styled.label<{
    $disabled: boolean;
    $checked: boolean;
    $withLabel: boolean;
    $size: TCheckboxSize;
}>`
    ${({ theme, $size, $checked, $disabled, $withLabel }) => {
        const styles = getCheckboxStyles(theme, $size, $checked, $withLabel);

        return css`
            --checkbox-width: ${styles.size};
            --checkbox-height: ${styles.size};
            --checkbox-border-radius: ${styles.borderRadius};
            --checkbox-check-size: ${styles.checkSize};
            --checkbox-check-stroke-width: ${styles.checkStrokeWidth};
            --checkbox-label-gap: ${styles.labelGap};
            --checkbox-margin: ${styles.checkboxMargin};

            ${$disabled
                ? css`
                      --checkbox-border-color: ${styles.disabled.borderColor};
                      --checkbox-background-color: ${styles.disabled.backgroundColor};
                      --checkbox-check-color: ${styles.disabled.checkColor};
                  `
                : css`
                      --checkbox-border-color: ${styles.borderColor};
                      --checkbox-background-color: ${styles.backgroundColor};
                      --checkbox-check-color: ${styles.checkColor};

                      input ~ :hover {
                          --checkbox-border-color: ${styles.hover.borderColor};
                          --checkbox-background-color: ${styles.hover.backgroundColor};
                          --checkbox-check-color: ${styles.hover.checkColor};
                      }

                      :focus,
                      :focus-within {
                          --checkbox-border-color: ${styles.focus.borderColor};
                          --checkbox-background-color: ${styles.focus.backgroundColor};
                          --checkbox-check-color: ${styles.focus.checkColor};
                          --checkbox-ring-color: ${styles.focus.ringColor};
                      }
                  `}
        `;
    }}

    cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
    position: relative;

    display: inline-flex;
    gap: var(--checkbox-label-gap);
`;

export const HiddenInput = styled.input`
    -webkit-appearance: none;
    appearance: none;
    position: absolute;

    opacity: 0;
    width: 0;
    height: 0;
`;
